import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 20 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.32 8.906 18 6.046v6.54zm-7.05 1.237 2.115 1.646a1.005 1.005 0 0 0 1.229 0l2.115-1.646L16.586 14H3.414zM5.679 8.906 2 12.586v-6.54zM10 9.733 2.629 4h14.742zM18 2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2"
        clipRule="evenodd"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
